import { render, staticRenderFns } from "./CoachTaskDetail.vue?vue&type=template&id=6dd2964c"
import script from "./CoachTaskDetail.vue?vue&type=script&lang=ts"
export * from "./CoachTaskDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports